import React from 'react';
import { Link } from 'react-router-dom';

export const NotFoundScreen: React.FC = () => (
  <div style={styles.page}>
    <div style={styles.card}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>🔍</div>
      <h2 style={styles.title}>Page not found</h2>
      <p style={styles.text}>The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" style={styles.btn}>← Go Home</Link>
    </div>
  </div>
);

const styles: Record<string, React.CSSProperties> = {
  page: { 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    minHeight: '100vh', 
    background: 'var(--sc-bg-primary, #F5F7FA)', 
    fontFamily: 'var(--sc-font-family, sans-serif)',
    padding: 16,
  },
  card: { 
    background: 'var(--sc-bg-secondary, #FFFFFF)', 
    borderRadius: 'var(--sc-radius-xl, 20px)', 
    padding: '48px 32px', 
    width: '100%',
    maxWidth: 440,
    textAlign: 'center' as const, 
    boxShadow: 'var(--sc-shadow-xl)',
    border: '1px solid var(--sc-border-light, #F1F5F9)',
    boxSizing: 'border-box',
  },
  title: { 
    fontSize: 22, 
    fontWeight: 800, 
    color: 'var(--sc-text-primary, #0A1C30)', 
    margin: '0 0 8px',
    fontFamily: 'var(--sc-font-display, sans-serif)',
    letterSpacing: '-0.5px',
  },
  text: { 
    fontSize: 14, 
    color: 'var(--sc-text-secondary, #475569)', 
    lineHeight: '1.6', 
    margin: '0 0 28px' 
  },
  btn: { 
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'var(--sc-touch-btn, 48px)',
    width: '100%',
    background: 'var(--sc-brand-gradient, #0C5ADB)', 
    color: 'var(--sc-text-on-brand, #FFF)', 
    borderRadius: 'var(--sc-radius-md, 12px)', 
    fontSize: 15, 
    fontWeight: 700, 
    textDecoration: 'none',
    boxShadow: 'var(--sc-shadow-brand)',
    transition: 'all var(--sc-transition-fast)',
  },
};
